import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { nanoid } from 'nanoid';

import { Sizes } from '../utils';

gsap.registerPlugin( ScrollTrigger );

export class Horizontal {
	constructor( container, options = {} ) {
		this.element = document.querySelector( container );
		this.sizes = new Sizes();
		this.options = {
			...options,
			devices: options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ],
			start: options.start || 'top top',
			speed: options.speed || 1,
		};
		this.isEnable = false;

		this.triggerID = `e-horizontal-${ nanoid( 9 ) }`;
	}

	init() {
		if (
			! this.element ||
			this.isEnable ||
			! this.options.devices.includes( this.sizes.device )
		)
			return;
		const theContainer = this.element.querySelector( '.el-container' );
		const allItems = gsap.utils.toArray( '*>.el-item', this.element );
		if ( ! theContainer || ! allItems.length ) return;

		const coreTween = gsap.timeline();
		if ( this.options.stayStart )
			coreTween.set( {}, {}, `+=${ this.options.stayStart }` );
		coreTween.to( theContainer, {
			x: () => getDisplacement( theContainer, allItems ) * -1,
			ease: 'none',
			duration: allItems.length,
		} );
		if ( this.options.stayEnd )
			coreTween.set( {}, {}, `+=${ this.options.stayEnd }` );

		const addVars = {};
		addVars.scrub = this.options.scrub || true;
		if ( this.options.snap ) addVars.snap = 1 / ( allItems.length - 1 );

		ScrollTrigger.create( {
			id: this.triggerID,
			trigger: this.element,
			start: this.options.start,
			pin: true,
			end: `+=${
				getDisplacement( theContainer, allItems ) / this.options.speed
			}`,
			invalidateOnRefresh: true,
			animation: coreTween,
			...addVars,
		} );
		this.isEnable = true;
	}

	kill() {
		ScrollTrigger.getById( this.triggerID )?.kill( true );
		this.isEnable = false;
	}

	resize() {
		this.kill();
		this.init();
	}

	destroy() {
		this.kill();
	}
}

const getDisplacement = ( container, items ) => {
	let size = 0;
	items.forEach( ( item ) => {
		size += item.offsetWidth;
	} );
	size -= container.offsetWidth;
	return size;
};
